import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import "./../style.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Chip, Tooltip } from "@mui/material";
import Loader from "../CommonLoader";
import DatagridComp from "../DatagridComp";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { AppContext } from "../../../Context/Context";
import RankedKeywordssvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg";
import totalpagessvg from "../Asset/esocardicon/aiready/totalpages.svg";
import readypagessvg from "../Asset/esocardicon/aiready/readypages.svg";
import needattentionsvg from "../Asset/esocardicon/aiready/needattention.svg";
import TotalExternalLinkssvg from "../Asset/esocardicon/ExternalLinks/TotalExternalLinks.svg";
import Rightsidebar from "../Rightsidebar/Rightsidebar";

export default function AiContentOptimizer() {
  const { isMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const domainId = esodata.domaindata.value.header_selected;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("content");
  const [urlInput, setUrlInput] = useState("");
  const [urlError, setUrlError] = useState("");
  const [apiopen, setapiOpen] = useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);

  const [contentOptData, setContentOptData] = useState({
    overall_readability_score: 0,
    overall_readability_status: "",
    ai_overall_readability_score: 0,
    ai_overall_readability_status: "",
    items: [],
  });

  const [seoKeywordData, setSeoKeywordData] = useState({
    existing_keywords: [],
    new_keyword_suggestions: [],
  });

  const [contentToneData, setContentToneData] = useState({
    overall_tone_score: 0,
    overall_tone_status: "",
    items: [],
  });

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const faqdatafun = async () => {
    const datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=94`;

    try {
      const faqResponse = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status === 599 ||
            error?.response?.status === 400 ||
            error?.response?.status === 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code === "ERR_NETWORK" ||
            error?.response?.status === 404
          ) {
            navigate("/errorpages");
          }
        });

      if (faqResponse?.data) {
        SetInitialfaqDateval(faqResponse?.data?.faqs);
      }
    } catch (err) { }
  };

  const handleToggle = () => {
    if (faqData !== 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }

    setToggle((pre) => !pre);
  };

  useEffect(() => {
    faqdatafun();
  }, []);

  const callApi = async () => {
    if (!urlInput.trim()) {
      setUrlError("Please enter a URL to analyze.");
      return;
    }
    if (!/^https:\/\/.+/.test(urlInput.trim())) {
      setUrlError("URL must start with https:// (e.g. https://www.example.com).");
      return;
    }
    setUrlError("");

    setLoading(true);
    setTableLoading(true);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}content/ai_content_optimizer/?user_domain_id=${domainId}&url=${encodeURIComponent(urlInput)}`,
        { headers: { Authorization: `${ApiToken}` } }
      );

      if (datavalue?.data) {
        const data = datavalue.data;

        if (data.content_optimization) {
          setContentOptData({
            overall_readability_score: data.content_optimization.overall_readability_score || 0,
            overall_readability_status: data.content_optimization.overall_readability_status || "",
            ai_overall_readability_score: data.content_optimization.ai_overall_readability_score || 0,
            ai_overall_readability_status: data.content_optimization.ai_overall_readability_status || "",
            items: (data.content_optimization.items || []).map((obj, idx) => ({
              ...obj,
              sid: idx + 1,
            })),
          });
        }

        if (data.seo_keyword_optimization) {
          setSeoKeywordData({
            existing_keywords: (data.seo_keyword_optimization.existing_keywords || []).map(
              (obj, idx) => ({ ...obj, sid: idx + 1 })
            ),
            new_keyword_suggestions: (data.seo_keyword_optimization.new_keyword_suggestions || []).map(
              (obj, idx) => ({ ...obj, sid: idx + 1 })
            ),
          });
        }

        if (data.content_tone_analyze) {
          setContentToneData({
            overall_tone_score: data.content_tone_analyze.overall_tone_score || 0,
            overall_tone_status: data.content_tone_analyze.overall_tone_status || "",
            items: (data.content_tone_analyze.items || []).map((obj, idx) => ({
              ...obj,
              sid: idx + 1,
            })),
          });
        }
      }
    } catch (error) {
      if (
        error?.response?.status === 599 ||
        error?.response?.status === 500 ||
        error?.response?.status === 400 ||
        error?.response?.status === 404
      ) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error);
      } else if (error?.code === "ERR_NETWORK") {
        navigate("/errorpages");
      }
    }

    setLoading(false);
    setTableLoading(false);
  };

  const getStatusChip = (status) => {
    if (!status) return <span>-</span>;
    const s = status.toLowerCase();
    const colorMap = {
      good: { bg: "#D1FAE5", color: "#059669" },
      fair: { bg: "#FEF3C7", color: "#D97706" },
      poor: { bg: "#FEE2E2", color: "#EF4444" },
    };
    const style = colorMap[s] || { bg: "#F3F4F6", color: "#374151" };
    return (
      <Chip
        label={status.charAt(0).toUpperCase() + status.slice(1)}
        size="small"
        sx={{
          backgroundColor: style.bg,
          color: style.color,
          fontWeight: 600,
          fontSize: "0.75rem",
          borderRadius: "9999px",
        }}
      />
    );
  };

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "-";

  const contentOptCards = [
    {
      value: contentOptData.overall_readability_score,
      title: "Overall Readability Score",
      badge: contentOptData.overall_readability_status?.toUpperCase() || "",
      iconSrc: RankedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: capitalize(contentOptData.overall_readability_status),
      title: "Overall Readability Status",
      iconSrc: totalpagessvg,
      iconColor: 2,
      bgColor: 2,
    },
    {
      value: contentOptData.ai_overall_readability_score,
      title: "AI Overall Readability Score",
      badge: contentOptData.ai_overall_readability_status?.toUpperCase() || "",
      iconSrc: readypagessvg,
      iconColor: 3,
      bgColor: 3,
    },
    {
      value: capitalize(contentOptData.ai_overall_readability_status),
      title: "AI Overall Readability Status",
      iconSrc: needattentionsvg,
      iconColor: 4,
      bgColor: 4,
    },
  ];

  const contentToneCards = [
    {
      value: contentToneData.overall_tone_score,
      title: "Overall Tone Score",
      badge: contentToneData.overall_tone_status?.toUpperCase() || "",
      iconSrc: RankedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: capitalize(contentToneData.overall_tone_status),
      title: "Overall Tone Status",
      iconSrc: TotalExternalLinkssvg,
      iconColor: 2,
      bgColor: 2,
    },
  ];

  const contentOptColumns = [
    {
      field: "sid",
      headerName: "#",
      minWidth: 60,
      flex: 0.3,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "tag",
      headerName: "Tag",
      minWidth: 130,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "content",
      headerName: "Content",
      minWidth: 280,
      flex: 2,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => (
        <Tooltip title={params.row.content}>
          <span style={{ whiteSpace: "normal", lineHeight: "1.5", padding: "6px 0" }}>
            {params.row.content}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "readability_score",
      headerName: "Readability Score",
      minWidth: 150,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "readability_status",
      headerName: "Status",
      minWidth: 120,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => getStatusChip(params.row.readability_status),
    },
    {
      field: "ai_suggestion",
      headerName: "AI Suggestion",
      minWidth: 280,
      flex: 2,
      headerAlign: "center",
      align: "left",
      description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
      renderCell: (params) => (
        <Tooltip title={params.row.ai_suggestion || "-"}>
          <span style={{ whiteSpace: "normal", lineHeight: "1.5", padding: "6px 0" }}>
            {params.row.ai_suggestion || "-"}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "ai_read_ability_score",
      headerName: "AI Readability Score",
      minWidth: 160,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.row.ai_read_ability_score ? params.row.ai_read_ability_score : "-",
    },
    {
      field: "ai_read_ability_status",
      headerName: "AI Status",
      minWidth: 130,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => getStatusChip(params.row.ai_read_ability_status),
    },
  ];

  const seoKeywordColumns = [
    {
      field: "sid",
      headerName: "#",
      minWidth: 60,
      flex: 0.3,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "keyword",
      headerName: "Keyword",
      minWidth: 200,
      flex: 1.5,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "search_volume",
      headerName: "Search Volume",
      minWidth: 140,
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "difficulty",
      headerName: "Difficulty",
      minWidth: 150,
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
  ];

  const contentToneColumns = [
    {
      field: "sid",
      headerName: "#",
      minWidth: 60,
      flex: 0.3,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "tag",
      headerName: "Tag",
      minWidth: 130,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "content",
      headerName: "Content",
      minWidth: 280,
      flex: 2,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => (
        <Tooltip title={params.row.content}>
          <span style={{ whiteSpace: "normal", lineHeight: "1.5", padding: "6px 0" }}>
            {params.row.content}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "tone_score",
      headerName: "Tone Score",
      minWidth: 120,
      flex: 0.6,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => getStatusChip(params.row.status),
    },
    {
      field: "weak_words_count",
      headerName: "Weak Words",
      minWidth: 120,
      flex: 0.6,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "negative_words_count",
      headerName: "Negative Words",
      minWidth: 140,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "passive_voice_count",
      headerName: "Passive Voice",
      minWidth: 130,
      flex: 0.6,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ai_suggestion",
      headerName: "AI Suggestion",
      minWidth: 280,
      flex: 2,
      headerAlign: "center",
      align: "left",
      description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
      renderCell: (params) => (
        <Tooltip title={params.row.ai_suggestion || "-"}>
          <span style={{ whiteSpace: "normal", lineHeight: "1.5", padding: "6px 0" }}>
            {params.row.ai_suggestion || "-"}
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading && <Loader />}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Helmet>
        <meta charSet="utf-8" />
        <title>AI Content Optimizer</title>
      </Helmet>

      {/* Page Header */}
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <h1 className="dashboard_header">AI Content Optimizer
                <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
              </h1>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb
                      breadcrumbValue={[
                        { title: 'Content' },
                        { title: "AI Content Optimizer", activeColor: true },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* URL Input Row */}
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div
                style={{ display: "flex", gap: "21px", justifyContent: "center" }}
                className="form-btn-center"
              >
                <div className="input-group">
                  <input
                    type="text"
                    value={urlInput}
                    onChange={(e) => { setUrlInput(e.target.value); if (urlError) setUrlError(""); }}
                    onKeyDown={(e) => e.key === "Enter" && callApi()}
                    placeholder="Enter URL to analyze (e.g. https://www.example.com)"
                    style={{
                      height: "44px",
                      width: "420px",
                      border: `1px solid ${urlError ? "#EF4444" : "#ff601f"}`,
                      borderRadius: "4px",
                      padding: "0 12px",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  {urlError && (
                    <p style={{ color: "#EF4444", fontSize: "12px", margin: "4px 0 0 2px" }}>
                      {urlError}
                    </p>
                  )}
                </div>
                <div className="button-group">
                  <button title="Analyze" className="btn_dashboard" onClick={callApi}>
                    Analyze
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* Tab Buttons */}
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <button
                    type="button"
                    className={`trendy-tab ${activeTab === "content" ? "active" : ""}`}
                    onClick={() => setActiveTab("content")}
                  >
                    Content Optimization
                  </button>
                  <button
                    type="button"
                    className={`trendy-tab ${activeTab === "seo" ? "active" : ""}`}
                    onClick={() => setActiveTab("seo")}
                  >
                    SEO Keyword
                  </button>
                  <button
                    type="button"
                    className={`trendy-tab ${activeTab === "tone" ? "active" : ""}`}
                    onClick={() => setActiveTab("tone")}
                  >
                    Content Tone Analyze
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* ── Content Optimization Tab ── */}
      {activeTab === "content" && (
        <>
          <Container maxWidth={false} className="dashboard-card-container">
            <Box>
              <Grid container className="dashboard-box-card">
                <Grid container spacing={3} justifyContent="center">
                  {contentOptCards.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Commoncard item={item} nonclikable={true} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="dashboard-container">
            <Box className="grid_table_shodow">
              <DatagridComp
                columns={contentOptColumns}
                rows={contentOptData.items}
                autoheightval={false}
                datagridval={2}
                tableLoading={tableLoading}
                getRowId={(row) => row.sid}
              />
            </Box>
          </Container>
        </>
      )}

      {/* ── SEO Keyword Tab ── */}
      {activeTab === "seo" && (
        <Container maxWidth={false} className="dashboard-container">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box className="grid_table_shodow">
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    padding: "12px 16px 4px",
                    margin: 0,
                    color: "#1f2937",
                  }}
                >
                  Existing Keywords
                </p>
                <DatagridComp
                  columns={seoKeywordColumns}
                  rows={seoKeywordData.existing_keywords}
                  autoheightval={false}
                  datagridval={2}
                  tableLoading={tableLoading}
                  getRowId={(row) => row.sid}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="grid_table_shodow">
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    padding: "12px 16px 4px",
                    margin: 0,
                    color: "#1f2937",
                  }}
                >
                  New Keyword Suggestions
                </p>
                <DatagridComp
                  columns={seoKeywordColumns}
                  rows={seoKeywordData.new_keyword_suggestions}
                  autoheightval={false}
                  datagridval={2}
                  tableLoading={tableLoading}
                  getRowId={(row) => row.sid}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      {/* ── Content Tone Analyze Tab ── */}
      {activeTab === "tone" && (
        <>
          <Container maxWidth={false} className="dashboard-card-container">
            <Box>
              <Grid container className="dashboard-box-card">
                <Grid container spacing={3} justifyContent="center">
                  {contentToneCards.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Commoncard item={item} nonclikable={true} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="dashboard-container">
            <Box className="grid_table_shodow">
              <DatagridComp
                columns={contentToneColumns}
                rows={contentToneData.items}
                autoheightval={false}
                datagridval={2}
                tableLoading={tableLoading}
                getRowId={(row) => row.sid}
              />
            </Box>
          </Container>
        </>
      )}

      {toggle && (
        <Rightsidebar
          close={() => setToggle(false)}
          setToggle={setToggle}
          initialfaqDateval={initialfaqDateval}
        />
      )}

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true,
        }}
        closeAlert={apihandleClose}
      />
    </div>
  );
}
